import { Link } from "@tanstack/react-router";
import type { Project } from "@/data/portfolio";

export function PortfolioCard({ project, span = "default" }: { project: Project; span?: "default" | "wide" | "tall" }) {
  const aspect = span === "wide" ? "aspect-[16/10]" : span === "tall" ? "aspect-[4/5]" : "aspect-square";
  return (
    <Link
      to="/gallery/$projectId"
      params={{ projectId: project.id }}
      className="relative group overflow-hidden rounded-3xl block border border-white/10"
    >
      <img src={project.image} alt={project.title} loading="lazy" decoding="async" width={1600} height={1600} className={`w-full ${aspect} object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]`} />
      <div className="absolute inset-0 bg-gradient-to-t from-[#030303] via-[#030303]/40 to-transparent opacity-95 group-hover:opacity-100 transition-opacity" />
      <div className="absolute bottom-0 left-0 right-0 p-7">
        <span className="text-[10px] uppercase tracking-[0.2em] text-amber-200 mb-2 block">{project.type} · {project.surface}</span>
        <h3 className="font-serif text-2xl text-white leading-tight mb-1">{project.title}</h3>
        <p className="text-sm text-zinc-400">{project.city}</p>
        <p className="text-xs text-zinc-500 mt-3 max-w-xs leading-relaxed line-clamp-2">{project.description}</p>
      </div>
    </Link>
  );
}
